import type { RouteRecordRaw } from 'vue-router';

export const exchangeRoutes: Array<RouteRecordRaw> = [
  {
    path: '/exchange',
    name: 'exchange',
    redirect: '/exchange/list',
    component: () => import('pages/trade/admin/exchange/McExchange.vue'),
    meta: {
      title: 'Exchanges',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'exchangeList',
        component: () => import('pages/trade/admin/exchange/ExchangeList.vue'),
        meta: {
          title: 'Exchanges List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'exchangeDetail',
        component: () => import('pages/trade/admin/exchange/ExchangeDetail.vue'),
        meta: {
          title: 'Exchange Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'exchangeNew',
        component: () => import('pages/trade/admin/exchange/ExchangeNew.vue'),
        meta: {
          title: 'New Exchange',
          requiresAuth: true,
        },
      },
      {
        path: 'in',
        name: 'exchangeIn',
        component: () => import('pages/trade/admin/exchange/ExchangeInDetail.vue'),
        meta: {
          title: 'Item Exchange (In)',
          requiresAuth: true,
        },
      },
      {
        path: 'out',
        name: 'exchangeOut',
        component: () => import('pages/trade/admin/exchange/ExchangeOutDetail.vue'),
        meta: {
          title: 'Item Exchange (Out)',
          requiresAuth: true,
        },
      },
    ],
  },
];
